<template>
  <pdl-dialog
    id="customization-save-dialog"
    :visible="isSaveDialogVisible"
    :title="$t('projectOne.config.save')"
    :z-index="9999"
    :close-dialog-tool-tip="$t('popup.close')"
    qaid="customization-save-dialog"
    @opened="focusTrapSaveDialog"
    @keydown="handleKeydown"
    @close="closeDialog"
  >
    <customization-save-build-body />
  </pdl-dialog>
</template>

<script>
import {PdlDialog} from '@pedal/pdl-dialog';
import {mapState, mapMutations} from 'vuex';
import CustomizationSaveBuildBody from './CustomizationSaveBuildBody.vue';
import {focusTrap, getAllFocusableElements} from '@/utils/accessibility/a11y-utils';

export default {
  components: {PdlDialog, CustomizationSaveBuildBody},

  data() {
    return {
      focusableElements: [],
    };
  },

  computed: {
    ...mapState('bikeCustomization', [
      'isSaveDialogVisible',
      'reopenPreviouslyOpenDialog',
      'isProcessingCustomizationAction',
    ]),
    ...mapState('backend', ['isUserLoggedIn']),
  },
  watch: {
    isSaveDialogVisible(newVal) {
      if (newVal) {
        this.setReopenPreviouslyOpenDialog(false);
      }
      this.setIsDialogOpen(newVal);
    },
  },
  mounted() {
    if (!this.reopenPreviouslyOpenDialog || !this.isUserLoggedIn) {
      this.setIsSaveDialogVisible(false);
    }
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setIsSaveDialogVisible',
      'setHasQueuedSaveAction',
      'setReopenPreviouslyOpenDialog',
      'setIsDialogOpen',
    ]),

    closeDialog() {
      this.setIsSaveDialogVisible(false);
      this.setHasQueuedSaveAction(false);
      if (!this.isProcessingCustomizationAction) {
        this.setReopenPreviouslyOpenDialog(false);
      }
    },
    focusTrapSaveDialog() {
      const dialog = document.querySelector('#customization-save-dialog');
      this.focusableElements = getAllFocusableElements(dialog);
    },
    handleKeydown(event) {
      focusTrap(event, this.focusableElements);
    },
  },
};
</script>
